import React from "react";
import { FormControl, FormLabel, FormHelperText, Input, useColorModeValue } from "@chakra-ui/react";

/**
 * Labeled Chakra input with optional helper text, shared across payments forms.
 * When `children` is provided it replaces the default Input (used for Select/Textarea).
 * @param {Object} props - Field props
 * @param {string} props.label - Field label
 * @param {string} [props.value] - Input value
 * @param {Function} [props.onChange] - Receives the raw next value
 * @param {string} [props.helper] - Helper text below the field
 * @param {boolean} [props.isRequired] - Marks the field as required
 * @param {React.ReactNode} [props.children] - Custom control replacing the default Input
 * @returns {React.ReactElement}
 */
function PaymentField({ label, value, onChange, helper, isRequired, children, ...rest }) {
    const labelColor = useColorModeValue("secondaryGray.900", "white");
    const helperColor = useColorModeValue("secondaryGray.600", "secondaryGray.400");
    return (
        <FormControl isRequired={isRequired}>
            <FormLabel fontSize="sm" fontWeight="600" color={labelColor} mb="4px">{label}</FormLabel>
            {children || (
                <Input value={value} onChange={(e) => onChange(e.target.value)} borderRadius="12px" {...rest} />
            )}
            {helper && <FormHelperText fontSize="xs" color={helperColor}>{helper}</FormHelperText>}
        </FormControl>
    );
}

export default PaymentField;
